export const hasExpired = (expiresAt) => {
  if (typeof expiresAt !== 'number') {
    return undefined
  }

  const currentTimestamp = Math.floor(Date.now() / 1000)

  if (currentTimestamp > expiresAt) {
    return true
  }

  return false
}
